import React from 'react';
import { Newspaper } from 'lucide-react';
import { Translations } from '../../i18n/translations';

interface ArticlesPerPageSettingsProps {
  articlesPerPage: number;
  onArticlesPerPageChange: (count: number) => void;
  t: Translations;
}

export const ArticlesPerPageSettings: React.FC<ArticlesPerPageSettingsProps> = ({
  articlesPerPage,
  onArticlesPerPageChange,
  t,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-4 mb-4">
      <h3 className="font-bold mb-3 flex items-center gap-2 text-gray-900 dark:text-white">
        <Newspaper className="w-4 h-4" />
        {t.articlesPerPage}
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
        {t.articlesPerPageDesc}
      </p>
      <div className="flex items-center gap-4">
        <input
          type="range"
          min="6"
          max="30"
          step="3"
          value={articlesPerPage}
          onChange={(e) => onArticlesPerPageChange(parseInt(e.target.value, 10))}
          className="flex-1"
        />
        <span className="font-semibold text-lg w-32 text-right text-gray-900 dark:text-white">{articlesPerPage} {t.articles}</span>
      </div>
      <div className="flex gap-2 mt-3">
        {[9, 12, 15, 21].map((count) => (
          <button
            key={count}
            onClick={() => onArticlesPerPageChange(count)}
            className={`px-3 py-1 text-sm font-semibold border-2 ${
              articlesPerPage === count
                ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
            }`}
          >
            {count}
          </button>
        ))}
      </div>
    </div>
  );
};
